import { createContext, useContext } from 'react';
export const initialUserInputState = {
    searchTerm: '',
    updateUserInput: (_) => void 0,
};
export const UserInputStateContext = createContext(initialUserInputState);
UserInputStateContext.displayName = 'UserInputStateContext';
export const useUserInput = () => {
    const ctx = useContext(UserInputStateContext);
    if (!ctx) {
        return initialUserInputState;
    }
    return ctx;
};
//# sourceMappingURL=UserInputProviderShared.js.map